enum MutationType {
  SET_CURRENT_TASK = "task/SET_CURRENT_TASK",
  SET_TASK_CHAT_WEBSOCKET = "task/SET_TASK_CHAT_WEBSOCKET",
}

export default MutationType;
